/**
 * External dependencies
 */
import {
	ColumnControl, ImageUploadPlaceholder
} from '~cartzillagb/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { getBootstrapClasses, range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl, RangeControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.features-list-block.edit.inspector.style.before', 'cartzillagb/features-list-block', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		limit,
		lgColumns,
		mdColumns,
		smColumns,
		enableheader,
		enableFooter
	} = attributes


	return (
		<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
			<ToggleControl
				label={ __( 'Enable Container', i18n ) }
				checked={ enableContainer }
				onChange={ enableContainer => setAttributes( { enableContainer } ) }
			/>
			<ToggleControl
				label={ __( 'Enable Header', i18n ) }
				checked={ enableheader }
				onChange={ enableheader => setAttributes( { enableheader } ) }
			/>
			<ToggleControl
				label={ __( 'Enable Footer', i18n ) }
				checked={ enableFooter }
				onChange={ enableFooter => setAttributes( { enableFooter } ) }
			/>
			<RangeControl
				label={ __( 'Limit' ) }
				value={ limit }
				onChange={ limit => setAttributes( { limit } ) }
				min={ 1 }
				max={ applyFilters( 'cartzillagb.features-list-block.edit.inspector.max.limit', 12 ) }
			/>
			<ColumnControl
				label={ __("Cloumn Width", i18n ) }
				mdColumns={ mdColumns }
				mdMin={ 1 }
				mdMax={ 12 }
				smColumns={ smColumns }
				smMin={ 1 }
				smMax={ 12 }
				lgColumns={ lgColumns !== undefined ? lgColumns : 1 }
				lgMin={ 1 }
				lgMax={ 12 }
				onChangelg={ value => setAttributes( { lgColumns: value } ) }
				onChangemd={ value => setAttributes( { mdColumns: value } ) }
				onChangesm={ value => setAttributes( { smColumns: value } ) }
			/>
							
		</PanelBody>
		
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		enableContainer,
		limit,
		lgColumns,
		mdColumns,
		smColumns,
		enableheader,
		heading,
		footertext,
		enableFooter
	} = attributes

	const mainClasses = classnames( [
		className,
		'features-block',
		'py-3 py-lg-4'
	], applyFilters( 'cartzillagb.features-list-block.main-block.classes', {
		'container': enableContainer,
	}, props ) )

	const headingComp = (
		<RichText
			tagName='h2'
			className={ `text-center mb-4` }
			value={ heading || 'Cartzilla Feature <span class="font-weight-light">Highlights</span>' }
			onChange={ heading => setAttributes( { heading } ) }
			placeholder={ __( 'heading' ) }
			keepPlaceholderOnFocus
		/>
	)

	const content = range( 1, ( limit ) + 1 ).map( i => {


		const title = attributes[ `title${ i }` ]
		const desc = attributes[ `desc${ i }` ]
		const mediaURL = attributes[ `mediaURL${ i }` ]

		let defaulttitle =''
		let defaultdesc =''
		

		if ( (i % 12 ) === 1 ) {
			defaulttitle = (__('Kick-start Your Development', i18n ))
			defaultdesc = (__('Start your development process fast and easy with Node.js and Gulp setup. Configuration files are included in download package. Full tasks automation.', i18n ))
		}

		if ( (i % 12 ) === 2 ) {
			defaulttitle = (__('Easy to Customize with Sass', i18n ))
			defaultdesc = (__('Cartzilla is built using Sass. Easily change colors, typography and much more. It is the most mature, stable, and powerful CSS extension language in the world.', i18n ))
		}
		if ( (i % 12 ) === 3 ) {
			defaulttitle = (__('Pug - Node Templating Engine', i18n ))
			defaultdesc = (__('No need to write huge amount of HTML, if you don’t want to. Pug provides features not available in plain HTML like variables, includes, mixins, functions, etc.', i18n ))
		}
		if ( (i % 12 ) === 4 ) {
			defaulttitle = (__('Built With Bootstrap 4', i18n ))
			defaultdesc = (__('Cartzilla is the powerful e-commerce front-end solution based on Bootstrap 4 - the world&#146;s most popular responsive, mobile-first front-end component library.', i18n ))
		}
		if ( (i % 12 ) === 5 ) {
			defaulttitle = (__('40+ Flexible Components', i18n ))
			defaultdesc = (__('Besides styling all default Bootstrap 4 components Cartzilla introduces lots of new flexible, customizable and reusable elements you can use across the website.', i18n ))
		}
		if ( (i % 12 ) === 6 ) {
			defaulttitle = (__('Mobile Friendly Interface', i18n ))
			defaultdesc = (__('It&#146;s not a surprise that nowadays over 70% of users shop online using their mobile devices. Cartzilla is 100% responsive and optimized for small touch screens.', i18n ))
		}
		if ( (i % 12 ) === 7 ) {
			defaulttitle = (__('Google Fonts', i18n ))
			defaultdesc = (__('Cartzilla uses Google fonts which are free, fast to load and of very high quality. Currently Google fonts library includes 870+ font families to choose from.', i18n ))
		}
		if ( (i % 12 ) === 8 ) {
			defaulttitle = (__('Touch-enabled Sliders', i18n ))
			defaultdesc = (__('In the era of touch screens it&#146;s important to ensure great user experience on handheld devices, especially when it comes to such frequently used interface component as slider.', i18n ))
		}
		if ( (i % 12 ) === 9 ) {
			defaulttitle = (__('Vector Based HD Ready Icons', i18n ))
			defaultdesc = (__('Cartzilla is equiped with font-based icon pack to ensure that infographics and interface icons look sharp on any device with any screen resolution and pixel density.', i18n ))
		}
		if ( (i % 12 ) === 10 ) {
			defaulttitle = (__('W3C Valid HTML Code', i18n ))
			defaultdesc = (__('All HTML files are checked via W3C validator to ensure 100% valid code. As you probably know invalid HTML limits innovation, but Cartzilla is innovative at its core.', i18n ))
		}

		if ( (i % 12 ) === 11 ) {
			defaulttitle = (__('Future-proof JavaScript', i18n ))
			defaultdesc = (__('Cartzilla core scripts as well as all dependencies are written in vanilla JS. The only component that requires jQuery is Bootstrap itself. But that will change soon.', i18n ))
		}

		if ( (i % 12 ) === 0 ) {
			defaulttitle = (__('Detailed Documentation', i18n ))
			defaultdesc = (__('Download package includes links to online documentation. It covers all crucial information about how to get started, customize template and components usage.22qa	q', i18n ))
		}


		const imageComp = (
			<ImageUploadPlaceholder
				imageURL={ mediaURL }
				onRemove={ () => {
					setAttributes( {
						[ `mediaURL${ i }` ]: '',
					} )
				} }
				onChange={ ( { url } ) => {
					setAttributes( {
						[ `mediaURL${ i }` ]: url,
					} )
				} }
				hasRemove={ false }
				render={ <img src={ mediaURL } className="inline-block mb-3" width="90" alt={ __( 'Image', i18n ) } /> }
			/>
		)


		const bootstrapClass = getBootstrapClasses( undefined, smColumns, mdColumns, lgColumns )

		const output = (
			<div className={ `${ bootstrapClass } mb-grid-gutter pb-2` }  key={ i }>
				{ imageComp }
				
				<RichText
					tagName='h6'
					value={ title || defaulttitle }
					onChange={ title => setAttributes( { [ `title${ i }` ]: title } ) }
					placeholder={ __( 'Title' ) }
					keepPlaceholderOnFocus
				/>
				<RichText
					tagName='p'
					className={ `font-size-ms text-muted mb-0` }
					value={ desc || defaultdesc }
					onChange={ desc => setAttributes( {  [`desc${ i }` ]: desc } ) }
					placeholder={ __( 'Desc' ) }
					keepPlaceholderOnFocus
				/>
					
			</div>
		)
		return output
	} )
		

	return (
		<section className="py-5">
			<div className={ mainClasses }>
				<Fragment>
					{ enableheader &&
						headingComp
					}
					<div className="row text-center pt-4">
						{ content }
					</div>
					{ enableFooter && 
						<RichText
							tagName='h6'
							className={ `text-center` }
							value={ footertext || 'And much more...' }
							onChange={ footertext => setAttributes( { footertext } ) }
							placeholder={ __( 'Text' ) }
							keepPlaceholderOnFocus
						/>
					}
				</Fragment>
			</div>
		</section>
	)  
}

export default compose(
	withTabbedInspector( [ 'style','advanced' ] ),
)( edit )